import { PolicySubTypeEnum } from '.';
import {
  MigrationService,
  MigrationStatus,
} from '../pages/Administrator/ServiceAccount/types';
import { Service } from '@Types/app';

// for provision and reAuth ,  the 'Service' same to App type
// export enum Service {
//   // service based provision
//   Exchange = 'exchange',
//   OneDrive = 'oneDrive',
//   SharePoint = 'sharePoint',
//   Box = 'box',
//   Dropbox = 'dropbox',
//   GoogleDrive = 'googleDrive',
//   SalesforceSandbox = 'salesforceSandbox',
//   SalesforceProduction = 'salesforceProduction',
//   Gmail = 'gmail',
//   IdentityProtection = 'identityProtection',
//   Teams = 'teams',
//   TeamsChat = 'teamsChat',
//   MIP = 'mip',
//   ExchangeServer = 'exchangeServer',
//   ExchangeInline = 'exchangeInline',
//   GmailInline = 'gmailInline',
//
//   // standalone app based provision
//   Mitigation = 'mitigation',
//   Soc = 'soc',
//   SocManagement = 'socManagement',
//   O365AuditLog = 'o365AuditLog',
// }

export enum ProvisionStatusEnum {
  NotStarted = 'notStarted',
  Provisioned = 'provisioned',
  Provisioning = 'provisioning',
  Failure = 'failure',

  // just for poc
  // "status": "tokenCreated",
  // "isPocProvision": true,
  TokenCreated = 'tokenCreated',
}

export enum PolicyModeString {
  NormalPolicy = 'normal',
  DefaultPolicy = 'default',
  DefaultMonitorPolicy = 'defaultMonitor',
  DefaultXDRMonitorPolicy = 'defaultXDRMonitor',
}

// {
//   "status": "notStarted",
//   "authorization": {
//       "status": "notStarted",
//       "apps": [
//           {
//               "app": "sharePoint",
//               "status": "notStarted",
//               "appId": "6608f2d8-6c3f-406d-a12c-9cb345e9cf99"
//           }
//       ]
//   }
// }
export interface ProvisionStatus {
  status: ProvisionStatusEnum;
  isPocProvision?: boolean;
  [key: string]: any;
}

export interface PolicyEnableStatus {
  policySubtype?: PolicySubTypeEnum;
  atp: PolicyModeString | 'none';
  dlp: PolicyModeString | 'none';
}

export interface ServiceStatus {
  provisionStatus: ProvisionStatus;
  policyEnableStatus: PolicyEnableStatus[];
}

export interface ProvisionModalState {
  orgId: string;
  isOpen: boolean;
  onClose: () => void;
  provisionStatus: ProvisionStatus;
}

export enum EnabledPolicyTypeEnum {
  Default = '1',
  DefaultMonitor = '2',
  None = '3',
}

export enum TokenStatus {
  NotStarted = 'notStarted',
  Created = 'created',
  Creating = 'creating',
  Failure = 'failure',
}
export enum IdSyncStatus {
  NotStarted = 'notStarted',
  Finished = 'finished',
  Syncing = 'syncing',
  Failure = 'failure',
}

export enum IdSyncMode {
  Full = 'full', // Normal full sync mode
  Poc = 'poc', // Poc sync mode
  Migration = 'migration', // Migration sync mode
}

export enum TargetType {
  Domain = 'domain',
  User = 'user',
  Objects = 'object',
  Profiles = 'profile',
  Communities = 'community',
  HPU = 'hpu',
}

export enum PaymentModel {
  ModelA = 'A',
  ModelB = 'B',
  Evaluation = 'Evaluation',
}

export interface UserAppInfo {
  appId: string;
  AppSecret: string;
}
//-----------------------------------------------type for provision api res and rep start-----------------------------------------------//

export type ServicesStatusListRes = {
  [key in Service]?: ServiceStatus;
};

export interface ProvisionAppInfo {
  app: Omit<Service, Service.ExchangeInline>;
  installAppUrl: null | string;
  authenticationUrl: string;
  appId: string;
}

export type AuthenticationInfoRes = ProvisionAppInfo[]; // for single app provision

export type MultiAppsAuthenticationInfoRes = ProvisionAppInfo[]; // for multi apps provision, like exchange inline

export interface SpMigrationAuthInfo {
  app: MigrationService.SharePoint;
  authenticationUrl: string;
  appId: string;
}
export interface OdMigrationAuthInfo {
  app: MigrationService.OneDrive;
  authenticationUrl: string;
  appId: string;
}

export type AuthenticationInfoForSpodMigrationRes =
  | [SpMigrationAuthInfo]
  | [OdMigrationAuthInfo]
  | [SpMigrationAuthInfo, OdMigrationAuthInfo];

export interface SpMigrationStatusInfo {
  app: MigrationService.SharePoint;
  status: 'created' | 'failure';
}
export interface OdMigrationStatusInfo {
  app: MigrationService.OneDrive;
  status: 'created' | 'failure';
}

export interface MigrationStatusForSpodMigrationRes {
  status: MigrationStatus;
  authorization?: {
    status: string; // status: 'failure';
    apps: [SpMigrationStatusInfo, OdMigrationStatusInfo];
  };
}

export interface GmailInlineSetting {
  inboundHostname: string;
  outboundHostname: string;
  outboundLoopHeader: string;
  inboundLoopHeader: string;
}
//-----------------------------------------------type for provision api res and rep  end -----------------------------------------------//

/**
 * @description error code from apiGetAuthenticationInfo response
 */
export enum RejectProvisionReason {
  /**
   * @description: if exchange online poc provision, other o365 service can not do provision, exchange online poc sync partial user, but other o365 service sync all user
   */
  PocConflict = 'PROVISION;NEED_POC_UPGRADE',
  /**
   * @description: if an o365 services is syncing user (in provision progress), other o365 service can not do provision
   */
  ServiceConflict = 'PROVISION;CONFLICT',
}

/**
 * @description Response type for getReauthRequiredOrgs API
 * Used for ACS (Azure Access Control Service) retirement notification
 */
export interface ReauthRequiredOrg {
  orgName: string;
  serviceName: string;
}

export interface ReauthRequiredOrgsResponse {
  traceId: string;
  data: ReauthRequiredOrg[];
}
